export default Object.freeze({
  Ordered: 1,
  Grouped: 2,
});
